// src/screens/customer/browseBiddings/BrowseBiddings.jsx
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import BiddingCard from "../../../../components/customer/biddingCard/BiddingCard";
import BiddingFilters from "../../../../components/customer/biddingFilter/BiddingFilters";
import BiddingDetails from "../../../../subscreen/customer/biddingDetails/BiddingDetails";
import MyNavbar from "../../../../components/customer/navigationbar/MyNavbar";
import { LayoutGrid, List, Search } from "lucide-react";
import "../../../../assets/css/customer/browseBidding/BrowseBidding.css";
import Footer from "../../../../subscreen/customer/footer/Footer";

const BrowseBiddings = () => {
  const { baseUrl } = useContext(AppContext);
  const [allBiddings, setAllBiddings] = useState([]);
  const [filteredBiddings, setFilteredBiddings] = useState([]);
  const [selectedBidding, setSelectedBidding] = useState(null);
  const [viewMode, setViewMode] = useState("grid");

  const viewActiveBiddings = () => {
    axios.get(`${baseUrl}/customer/bidding/viewactivebids`)
      .then((res) => {
        console.log(res.data);
        setAllBiddings(res.data.activebids || []);
        setFilteredBiddings(res.data.activebids || []);
      })
      .catch((err) => {
        console.log(err.response?.data || err.message);
      });
  };

  useEffect(() => {
    viewActiveBiddings();
  }, []);

  const handleFilterChange = (filters) => {
    let filtered = [...allBiddings];

    if (filters.category && filters.category !== "all")
      filtered = filtered.filter((b) => b.category === filters.category);

    if (filters.condition && filters.condition !== "all")
      filtered = filtered.filter((b) => b.condition === filters.condition);

    if (filters.priceRange)
      filtered = filtered.filter(
        (b) => b.currentBid >= filters.priceRange.min && b.currentBid <= filters.priceRange.max
      );

    if (filters.search)
      filtered = filtered.filter((b) =>
        b.productName.toLowerCase().includes(filters.search.toLowerCase())
      );

    if (filters.sortBy) {
      switch (filters.sortBy) {
        case "price-low": filtered.sort((a, b) => a.currentBid - b.currentBid); break;
        case "price-high": filtered.sort((a, b) => b.currentBid - a.currentBid); break;
        case "ending-soon": filtered.sort((a, b) => new Date(a.endDate) - new Date(b.endDate)); break;
        case "newest": filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); break;
        default: break;
      }
    }

    setFilteredBiddings(filtered);
  };

  return (
    <div className="browse-container">
      <MyNavbar />

      <div className="pl-page-header">
        <div className="pl-header-content">
          <h1 className="pl-page-title">All Active Bids</h1>
          <p className="pl-page-subtitle">
            Discover premium quality furniture for every room in your home
          </p>
        </div>
      </div>

      <div className="browse-body">
        <BiddingFilters onFilterChange={handleFilterChange} />

        <div className="browse-toolbar">
          <span className="browse-count">
            {filteredBiddings?.length}{" "}
            {filteredBiddings.length === 1 ? "Bidding" : "Biddings"}
          </span>
          <div className="browse-view-toggle">
            <button
              className={`browse-view-btn ${viewMode === "grid" ? "active" : ""}`}
              onClick={() => setViewMode("grid")}
              title="Grid View"
            >
              <LayoutGrid size={17} />
            </button>
            <button
              className={`browse-view-btn ${viewMode === "list" ? "active" : ""}`}
              onClick={() => setViewMode("list")}
              title="List View"
            >
              <List size={17} />
            </button>
          </div>
        </div>

        {filteredBiddings.length === 0 ? (
          <div className="browse-empty">
            <Search size={36} className="browse-empty-icon" />
            <h3 className="browse-empty-title">No biddings found</h3>
            <p className="browse-empty-text">Try adjusting your filters or check back later</p>
          </div>
        ) : (
          <div className={`browse-grid ${viewMode === "list" ? "list-mode" : ""}`}>
            {filteredBiddings.map((bidding) => (
              <BiddingCard
                key={bidding.id}
                bidding={bidding}
                onView={setSelectedBidding}
                viewMode={viewMode}
              />
            ))}
          </div>
        )}
      </div>

      {/* ✅ mode="browse" + onBidPlaced refresh */}
      {selectedBidding && (
        <BiddingDetails
          bidding={selectedBidding}
          isOpen={!!selectedBidding}
          onClose={() => setSelectedBidding(null)}
          mode="browse"
          onBidPlaced={viewActiveBiddings}
        />
      )}

      <Footer />
    </div>
  );
};

export default BrowseBiddings;